module.exports = __webpack_public_path__ + "img/tpc-31.93cae696.webp";